import { render, staticRenderFns } from "./dataEvaluation.vue?vue&type=template&id=38900764&scoped=true"
import script from "./dataEvaluation.vue?vue&type=script&lang=js"
export * from "./dataEvaluation.vue?vue&type=script&lang=js"
import style0 from "./dataEvaluation.vue?vue&type=style&index=0&id=38900764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38900764",
  null
  
)

export default component.exports